export function showChatbotMessengerEffect() {
  try {
    // @ts-expect-error
    Intercom("showNewMessage");
  } catch (err) {
    console.error(err);
  }
}
